import gql from 'graphql-tag'

export default ($edgewise) => ({
  get: (...args) => get($edgewise, ...args)
})

async function get($edgewise, projectId) {
  try {
    const { project } = await $edgewise.graphqlClient.request(
      gql`
        query jssdk_get_project($projectId: ID!) {
          project(id: $projectId) {
            id
            title
            slug
            status
            address {
              thoroughfare
              locality
              administrativeArea
              postalCode
              location {
                longitude
                latitude
              }
            }
            salesOffice {
              email
              phone
            }
          }
        }
      `,
      { projectId }
    )

    return project
  } catch (err) {
    console.error(err)
    throw err
  }
}
